const IOS_UNIVERSAL_LINK = 'https://static.vigolive.cn/links/';
const REDIRECTED_SESSION_KEY = 'vigolive-ios-universal-link-attempted';

function isIOS() {
  const userAgent = window.navigator.userAgent;
  const isIPadDesktopMode = window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;

  return /iPad|iPhone|iPod/.test(userAgent) || isIPadDesktopMode;
}

function isWeChatBrowser() {
  return /MicroMessenger/i.test(window.navigator.userAgent);
}

export function redirectIOSHomePageToApp() {
  if (
    window.location.pathname !== '/' ||
    !isIOS() ||
    isWeChatBrowser() ||
    window.sessionStorage.getItem(REDIRECTED_SESSION_KEY)
  ) {
    return;
  }

  window.sessionStorage.setItem(REDIRECTED_SESSION_KEY, 'true');
  window.location.replace(IOS_UNIVERSAL_LINK);
}
